const coconutDatePulpData = {
  hero_section: {
    title: "Premium Tender Coconut Date Pulp Collection",
    description: "100% Natural • No Preservatives • Unique Blend",
    src: "videos/coconut-date-processing.webm",
  },
  description: {
    title: "Premium Tender Coconut Date Pulp Collection",
    main_description:
      "Discover our unique blend of 100% natural coconut and date pulp, combining tropical coconut flavor with natural date sweetness for innovative applications.",
    segment_description:
      "Perfect for specialty beverages, premium desserts, and health-focused food applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Tender Coconut Date Pulp",
    description: "Our tender coconut date pulp combines the tropical richness of coconut with the natural sweetness of dates. This unique blend offers exceptional nutritional value and distinctive flavor perfect for health-conscious and gourmet applications.",
    image: "New-Images/Tender coconut with dates.png",
    mainFeatures: [
      "Unique coconut-date blend",
      "Natural sweetness from dates",
      "Rich nutritional profile",
      "Perfect for health foods",
      "Premium quality ingredients",
      "Consistent blend ratio"
    ]
  },
  products: [
    {
      id: "1",
      name: "Premium Tender Coconut Date Blend",
      image: "New-Images/Tender coconut with dates.png",
      features: [
        "Unique flavor combination",
        "Natural sweetness",
        "Rich in nutrients",
        "Perfect for health foods"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Tender Coconut Date Pulp Excellence",
    description: "Our tender coconut date pulp is crafted by carefully blending the finest coconuts and dates using advanced processing techniques. We maintain strict quality control to ensure consistent flavor balance, nutritional value, and texture in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Health & Gourmet Applications",
    subline: "From health foods to gourmet treats – unique natural sweetness in every application!",
    description:
      "Ideal for health food manufacturers, gourmet producers, specialty beverage makers, and food service providers who seek unique flavors and natural nutrition.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "health-applications.webp",
      title: "Health Food Applications",
      description:
        "Perfect for energy bars, health drinks, and nutritional products combining tropical and natural sweetness.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Specialty Dessert Applications",
      description:
        "Ideal for premium desserts, specialty sweets, and gourmet confectionery with unique flavor profiles.",
    },
    {
      id: 3,
      image: "beverage-applications.webp",
      title: "Specialty Beverage Applications",
      description:
        "Excellent for health smoothies, specialty drinks, and nutritional beverages with natural sweetness.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural coconut and date goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Unique Innovation",
      image: "unique-innovation.webp",
      title: "Unique Innovation",
      description:
        "Innovative blending techniques to create distinctive flavor combinations",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Tender Coconut Date Pulp",
    description: "Discover the perfect blend of innovation, nutrition, and authentic flavors that make our tender coconut date pulp the preferred choice for specialty food manufacturers worldwide.",
  },
};

export default coconutDatePulpData;
